import { get } from 'stash/utils';
import { createSelector } from 'reselect';

type UserState = {
	entities?: {
		user?: Record<string, unknown>;
	};
};

export const userSelector = (state: UserState) =>
	get(state, 'entities.user', {}) as Record<string, unknown>;

export const userLegalNameSelector = createSelector(userSelector, (user) => {
	const first_name = get(user, 'first_name', '') as string;
	const last_name = get(user, 'last_name', '') as string;
	return {
		first_name,
		last_name,
	};
});
